import React from 'react';

const WireContext = React.createContext({});

export default WireContext;
